import { differenceInYears, parseISO } from 'date-fns';

export const user = (state) => state.user;

export const isLoggedIn = (state) => state.user !== undefined;

export const isMainInsured = (state) => state.user.role.isMainInsured();
export const isPartner = (state) => state.user.role.isPartnerInsured();
export const isCoCustomer = (state) => state.user.role.isCoInsured();

export const fullName = (state) => `${state.user.initials} ${state.user.fullLastName}`;

export const permissions = (state) => state.permissions;

export const label = (state) => state.label;

export const isYoungerThan18 = (state) => differenceInYears(new Date(), parseISO(state.user.birthDate)) < 18;
